import React, { useState } from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import FloatingDegreeIcon from "../components/Home/FloatingDegreeIcon";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import { 
  FaSearch, 
  FaFilter, 
  FaGraduationCap, 
  FaClock, 
  FaUsers, 
  FaArrowRight,
  FaLaptop,
  FaShieldAlt,
  FaCode,
  FaChartLine,
  FaDatabase,
  FaNetworkWired,
  FaMobileAlt,
  FaCloud,
  FaRobot,
  FaMicroscope,
  FaCog,
  FaBook,
  FaBuilding,
  FaGlobe,
  FaTrophy,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaUserTie,
  FaDesktop,
  FaTabletAlt,
  FaWifi,
  FaVolumeUp,
  FaEye,
  FaHandsHelping,
  FaClipboardList,
  FaChalkboardTeacher,
  FaCertificate,
  FaStar,
  FaHeart,
  FaShare,
  FaBookmark,
  FaTimes,
  FaCheckCircle,
  FaLightbulb,
  FaRocket,
  FaGlobeAmericas,
  FaBriefcase,
  FaAward
} from "react-icons/fa";

const Programs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("all");
  const [selectedField, setSelectedField] = useState("all");
  const [showFilters, setShowFilters] = useState(false);

  const programs = [
    {
      id: 1,
      name: "Bachelor of Computer Science",
      level: "Undergraduate",
      field: "Computer Science",
      duration: "4 Years",
      credits: "160",
      description: "Comprehensive computer science program covering algorithms, data structures, software engineering, and theoretical foundations.",
      icon: FaCode,
      careerOutcomes: ["Software Engineer", "Data Scientist", "Research Scientist", "System Architect"],
      admissionRequirements: ["High School Diploma", "Mathematics Grade B+", "English Proficiency", "Entrance Exam"],
      tuition: "TZS 2,500,000/year",
      startDate: "September 2024",
      applicationDeadline: "July 15, 2024",
      highlights: ["AI/ML Focus", "Research Opportunities", "Industry Internships", "Capstone Project"],
      curriculum: ["Programming Fundamentals", "Data Structures", "Algorithms", "Software Engineering", "Database Systems", "Computer Networks", "Operating Systems", "Machine Learning"]
    },
    {
      id: 2,
      name: "Bachelor of Information Technology",
      level: "Undergraduate",
      field: "Information Technology",
      duration: "3 Years",
      credits: "120",
      description: "Practical IT program focusing on systems administration, networking, web development, and enterprise solutions.",
      icon: FaLaptop,
      careerOutcomes: ["IT Administrator", "Web Developer", "System Analyst", "IT Consultant"],
      admissionRequirements: ["High School Diploma", "Mathematics Grade C+", "English Proficiency", "Basic Computer Skills"],
      tuition: "TZS 2,200,000/year",
      startDate: "September 2024",
      applicationDeadline: "July 15, 2024",
      highlights: ["Hands-on Labs", "Industry Certifications", "Project-based Learning", "Internship Program"],
      curriculum: ["IT Fundamentals", "Network Administration", "Web Development", "Database Management", "System Security", "Cloud Computing", "Project Management", "IT Ethics"]
    },
    {
      id: 3,
      name: "Bachelor of Cybersecurity",
      level: "Undergraduate",
      field: "Cybersecurity",
      duration: "3 Years",
      credits: "120",
      description: "Specialized cybersecurity program covering threat analysis, ethical hacking, digital forensics, and security management.",
      icon: FaShieldAlt,
      careerOutcomes: ["Cybersecurity Analyst", "Ethical Hacker", "Security Consultant", "Incident Responder"],
      admissionRequirements: ["High School Diploma", "Mathematics Grade B", "English Proficiency", "Background Check"],
      tuition: "TZS 2,800,000/year",
      startDate: "September 2024",
      applicationDeadline: "July 15, 2024",
      highlights: ["Hands-on Labs", "Industry Certifications", "Ethical Hacking", "Digital Forensics"],
      curriculum: ["Cybersecurity Fundamentals", "Network Security", "Ethical Hacking", "Digital Forensics", "Risk Management", "Cryptography", "Incident Response", "Security Policies"]
    },
    {
      id: 4,
      name: "Master of Computer Science",
      level: "Graduate",
      field: "Computer Science",
      duration: "2 Years",
      credits: "60",
      description: "Advanced computer science program with focus on research, specialization, and leadership in technology.",
      icon: FaCode,
      careerOutcomes: ["Senior Software Engineer", "Research Scientist", "Technical Lead", "Professor"],
      admissionRequirements: ["Bachelor's Degree in CS", "GPA 3.0+", "GRE Scores", "Research Proposal"],
      tuition: "TZS 3,500,000/year",
      startDate: "September 2024",
      applicationDeadline: "May 1, 2024",
      highlights: ["Research Focus", "Thesis Project", "Industry Collaboration", "Advanced Specializations"],
      curriculum: ["Advanced Algorithms", "Machine Learning", "Computer Vision", "Natural Language Processing", "Distributed Systems", "Software Architecture", "Research Methods", "Thesis Project"]
    },
    {
      id: 5,
      name: "Master of Business Administration (MBA)",
      level: "Graduate",
      field: "Business Administration",
      duration: "2 Years",
      credits: "60",
      description: "Comprehensive MBA program focusing on leadership, strategy, and digital transformation in business.",
      icon: FaBuilding,
      careerOutcomes: ["Business Manager", "Entrepreneur", "Consultant", "Executive"],
      admissionRequirements: ["Bachelor's Degree", "2+ Years Experience", "GMAT Scores", "Interview"],
      tuition: "TZS 4,000,000/year",
      startDate: "September 2024",
      applicationDeadline: "May 1, 2024",
      highlights: ["Executive Leadership", "Case Studies", "Networking", "Capstone Project"],
      curriculum: ["Strategic Management", "Financial Management", "Marketing Strategy", "Operations Management", "Leadership", "Digital Business", "Global Business", "Capstone Project"]
    },
    {
      id: 6,
      name: "Diploma in Data Science",
      level: "Diploma",
      field: "Data Science",
      duration: "2 Years",
      credits: "80",
      description: "Practical data science program covering statistics, programming, and machine learning applications.",
      icon: FaChartLine,
      careerOutcomes: ["Data Analyst", "Data Scientist", "Business Intelligence", "Research Analyst"],
      admissionRequirements: ["High School Diploma", "Mathematics Grade B+", "Basic Programming", "English Proficiency"],
      tuition: "TZS 1,800,000/year",
      startDate: "September 2024",
      applicationDeadline: "July 15, 2024",
      highlights: ["Big Data Tools", "Machine Learning", "Industry Projects", "Portfolio Development"],
      curriculum: ["Statistics", "Python Programming", "Data Visualization", "Machine Learning", "Big Data Analytics", "Database Systems", "Business Intelligence", "Capstone Project"]
    },
    {
      id: 7,
      name: "Certificate in Web Development",
      level: "Certificate",
      field: "Web Development",
      duration: "1 Year",
      credits: "40",
      description: "Intensive web development program covering front-end and back-end technologies.",
      icon: FaDesktop,
      careerOutcomes: ["Web Developer", "Frontend Developer", "Backend Developer", "Full-stack Developer"],
      admissionRequirements: ["High School Diploma", "Basic Computer Skills", "English Proficiency"],
      tuition: "TZS 1,200,000/year",
      startDate: "September 2024",
      applicationDeadline: "August 1, 2024",
      highlights: ["Modern Technologies", "Portfolio Projects", "Industry Mentorship", "Job Placement"],
      curriculum: ["HTML/CSS", "JavaScript", "React", "Node.js", "Database Design", "API Development", "Version Control", "Project Management"]
    },
    {
      id: 8,
      name: "Certificate in Cybersecurity",
      level: "Certificate",
      field: "Cybersecurity",
      duration: "1 Year",
      credits: "40",
      description: "Focused cybersecurity certificate program for professionals seeking security expertise.",
      icon: FaShieldAlt,
      careerOutcomes: ["Security Analyst", "Penetration Tester", "Security Consultant", "Compliance Officer"],
      admissionRequirements: ["IT Background", "Basic Networking", "English Proficiency"],
      tuition: "TZS 1,500,000/year",
      startDate: "September 2024",
      applicationDeadline: "August 1, 2024",
      highlights: ["Hands-on Labs", "Industry Certifications", "Real-world Scenarios", "Expert Instructors"],
      curriculum: ["Security Fundamentals", "Network Security", "Ethical Hacking", "Digital Forensics", "Risk Assessment", "Security Policies", "Incident Response", "Capstone Project"]
    }
  ];

  const levels = [
    { id: "all", name: "All Levels", count: programs.length },
    { id: "Undergraduate", name: "Undergraduate", count: programs.filter(p => p.level === "Undergraduate").length },
    { id: "Graduate", name: "Graduate", count: programs.filter(p => p.level === "Graduate").length },
    { id: "Diploma", name: "Diploma", count: programs.filter(p => p.level === "Diploma").length },
    { id: "Certificate", name: "Certificate", count: programs.filter(p => p.level === "Certificate").length }
  ];

  const fields = [
    { id: "all", name: "All Fields", count: programs.length },
    { id: "Computer Science", name: "Computer Science", count: programs.filter(p => p.field === "Computer Science").length },
    { id: "Information Technology", name: "Information Technology", count: programs.filter(p => p.field === "Information Technology").length },
    { id: "Cybersecurity", name: "Cybersecurity", count: programs.filter(p => p.field === "Cybersecurity").length },
    { id: "Data Science", name: "Data Science", count: programs.filter(p => p.field === "Data Science").length },
    { id: "Business Administration", name: "Business Administration", count: programs.filter(p => p.field === "Business Administration").length },
    { id: "Web Development", name: "Web Development", count: programs.filter(p => p.field === "Web Development").length }
  ];

  const filteredPrograms = programs.filter(program => {
    const matchesSearch = program.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         program.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         program.field.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesLevel = selectedLevel === "all" || program.level === selectedLevel;
    const matchesField = selectedField === "all" || program.field === selectedField;
    return matchesSearch && matchesLevel && matchesField;
  });

  return (
    <div>
      <Navbar />
      <FloatingDegreeIcon />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-custom-pink via-purple-900 to-indigo-900 text-white py-20 lg:py-32">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            Academic Programs
          </h1>
          <p className="text-xl sm:text-2xl mb-8 max-w-3xl mx-auto">
            Discover our comprehensive range of academic programs designed to prepare you for success in the digital age.
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-center">
            <div className="flex items-center gap-2">
              <FaGraduationCap className="text-gold text-2xl" />
              <span className="text-lg font-semibold">{programs.length} Programs</span>
            </div>
            <div className="flex items-center gap-2">
              <FaUsers className="text-gold text-2xl" />
              <span className="text-lg font-semibold">Multiple Levels</span>
            </div>
            <div className="flex items-center gap-2">
              <FaTrophy className="text-gold text-2xl" />
              <span className="text-lg font-semibold">Industry Focused</span>
            </div>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-6 items-center justify-between">
            {/* Search Bar */}
            <div className="flex-1 max-w-md">
              <div className="relative">
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search programs, fields, or careers..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-pink focus:border-transparent"
                />
              </div>
            </div>

            {/* Filter Button */}
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="flex items-center gap-2 px-6 py-3 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <FaFilter className="text-gray-600" />
              <span>Filter Programs</span>
            </button>
          </div>

          {/* Filter Options */}
          {showFilters && (
            <div className="mt-6 p-6 bg-white rounded-xl shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Level Filter */}
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">Degree Level</h3>
                  <div className="space-y-2">
                    {levels.map((level) => (
                      <button
                        key={level.id}
                        onClick={() => setSelectedLevel(level.id)}
                        className={`w-full p-3 rounded-lg text-left transition-colors ${
                          selectedLevel === level.id
                            ? "bg-custom-pink text-white"
                            : "bg-gray-50 hover:bg-gray-100"
                        }`}
                      >
                        <div className="flex justify-between items-center">
                          <span>{level.name}</span>
                          <span className="text-sm opacity-75">({level.count})</span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Field Filter */}
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">Field of Study</h3>
                  <div className="space-y-2">
                    {fields.map((field) => (
                      <button
                        key={field.id}
                        onClick={() => setSelectedField(field.id)}
                        className={`w-full p-3 rounded-lg text-left transition-colors ${
                          selectedField === field.id
                            ? "bg-gold text-white"
                            : "bg-gray-50 hover:bg-gray-100"
                        }`}
                      >
                        <div className="flex justify-between items-center">
                          <span>{field.name}</span>
                          <span className="text-sm opacity-75">({field.count})</span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Programs Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              {filteredPrograms.length} Program{filteredPrograms.length !== 1 ? 's' : ''} Found
            </h2>
            <p className="text-lg text-gray-600">
              Explore our comprehensive academic offerings
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            {filteredPrograms.map((program) => {
              const IconComponent = program.icon;
              return (
                <div key={program.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  {/* Program Header */}
                  <div className="p-6 border-b border-gray-100">
                    <div className="flex items-start gap-4 mb-4">
                      <div className="bg-custom-pink text-white p-3 rounded-xl">
                        <IconComponent className="text-2xl" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-gray-900 mb-1">{program.name}</h3>
                        <div className="flex items-center gap-4 text-sm">
                          <span className="bg-gold text-white px-2 py-1 rounded">{program.level}</span>
                          <span className="text-gray-600">{program.field}</span>
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">{program.description}</p>
                  </div>

                  {/* Program Details */}
                  <div className="p-6">
                    {/* Basic Info */}
                    <div className="grid grid-cols-3 gap-4 mb-6">
                      <div className="text-center p-3 bg-gray-50 rounded-lg">
                        <FaClock className="text-custom-pink mx-auto mb-1" />
                        <div className="text-sm font-semibold">{program.duration}</div>
                        <div className="text-xs text-gray-500">Duration</div>
                      </div>
                      <div className="text-center p-3 bg-gray-50 rounded-lg">
                        <FaGraduationCap className="text-custom-pink mx-auto mb-1" />
                        <div className="text-sm font-semibold">{program.credits}</div>
                        <div className="text-xs text-gray-500">Credits</div>
                      </div>
                      <div className="text-center p-3 bg-gray-50 rounded-lg">
                        <FaAward className="text-custom-pink mx-auto mb-1" />
                        <div className="text-sm font-semibold">{program.tuition}</div>
                        <div className="text-xs text-gray-500">Tuition</div>
                      </div>
                    </div>

                    {/* Career Outcomes */}
                    <div className="mb-6">
                      <h4 className="text-sm font-semibold text-gray-900 mb-2">Career Outcomes:</h4>
                      <div className="flex flex-wrap gap-1">
                        {program.careerOutcomes.slice(0, 3).map((outcome, index) => (
                          <span key={index} className="bg-gold text-white px-2 py-1 rounded text-xs">
                            {outcome}
                          </span>
                        ))}
                        {program.careerOutcomes.length > 3 && (
                          <span className="bg-gray-200 text-gray-600 px-2 py-1 rounded text-xs">
                            +{program.careerOutcomes.length - 3}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Highlights */}
                    <div className="mb-6">
                      <h4 className="text-sm font-semibold text-gray-900 mb-2">Program Highlights:</h4>
                      <ul className="space-y-1">
                        {program.highlights.map((highlight, index) => (
                          <li key={index} className="flex items-center gap-2 text-sm text-gray-600">
                            <FaCheckCircle className="text-gold text-xs" />
                            {highlight}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Admission Requirements */}
                    <div className="mb-6">
                      <h4 className="text-sm font-semibold text-gray-900 mb-2">Admission Requirements:</h4>
                      <ul className="space-y-1">
                        {program.admissionRequirements.slice(0, 3).map((req, index) => (
                          <li key={index} className="flex items-center gap-2 text-sm text-gray-600">
                            <div className="w-1.5 h-1.5 bg-custom-pink rounded-full"></div>
                            {req}
                          </li>
                        ))}
                        {program.admissionRequirements.length > 3 && (
                          <li className="text-sm text-gold">+{program.admissionRequirements.length - 3} more requirements</li>
                        )}
                      </ul>
                    </div>

                    {/* Important Dates */}
                    <div className="mb-6 p-3 bg-gray-50 rounded-lg">
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <div className="font-semibold text-gray-900">Start Date:</div>
                          <div className="text-gray-600">{program.startDate}</div>
                        </div>
                        <div>
                          <div className="font-semibold text-gray-900">Application Deadline:</div>
                          <div className="text-gray-600">{program.applicationDeadline}</div>
                        </div>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-3">
                      <button className="flex-1 bg-custom-pink text-white py-2 px-4 rounded-lg hover:bg-gold transition-colors duration-300 font-semibold text-sm flex items-center justify-center gap-2">
                        Apply Now
                        <FaArrowRight className="text-xs" />
                      </button>
                      <button className="px-4 py-2 border border-custom-pink text-custom-pink rounded-lg hover:bg-custom-pink hover:text-white transition-colors duration-300 text-sm">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {filteredPrograms.length === 0 && (
            <div className="text-center py-12">
              <FaSearch className="text-6xl text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-600 mb-2">No programs found</h3>
              <p className="text-gray-500">Try adjusting your search terms or filters</p>
            </div>
          )}
        </div>
      </section>

      {/* Program Statistics */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              Program Statistics
            </h2>
            <p className="text-lg text-gray-600">
              Our academic programs at a glance
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="bg-custom-pink text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FaGraduationCap className="text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{programs.length}</div>
              <div className="text-gray-600">Total Programs</div>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="bg-gold text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FaUsers className="text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">4</div>
              <div className="text-gray-600">Degree Levels</div>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="bg-custom-pink text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FaLightbulb className="text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">7</div>
              <div className="text-gray-600">Fields of Study</div>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="bg-gold text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FaTrophy className="text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">95%</div>
              <div className="text-gray-600">Job Placement Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* Application Process */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              How to Apply
            </h2>
            <p className="text-lg text-gray-600">
              Follow these simple steps to start your academic journey
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-custom-pink text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <span className="text-xl font-bold">1</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Choose Program</h3>
              <p className="text-gray-600 text-sm">Select the program that matches your career goals and interests</p>
            </div>

            <div className="text-center">
              <div className="bg-gold text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <span className="text-xl font-bold">2</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Check Requirements</h3>
              <p className="text-gray-600 text-sm">Review admission requirements and prepare necessary documents</p>
            </div>

            <div className="text-center">
              <div className="bg-custom-pink text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <span className="text-xl font-bold">3</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Submit Application</h3>
              <p className="text-gray-600 text-sm">Complete and submit your application before the deadline</p>
            </div>

            <div className="text-center">
              <div className="bg-gold text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <span className="text-xl font-bold">4</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Get Accepted</h3>
              <p className="text-gray-600 text-sm">Receive your acceptance letter and begin your journey</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default Programs;